export default "__VITE_PUBLIC_ASSET__351cd901__"